import React from 'react';
import { faComments } from '@fortawesome/pro-duotone-svg-icons/faComments';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CommentsDuotoneIcon(props) {
  return <FontAwesomeIcon icon={faComments} {...props} />;
}
